import { Chip, Grid, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

import { ManagementWidgetShell, StepPipelineList } from "./managementDashboardWidgets";

const LendingOverviewSection = ({ loading, error, data, onRetry }) => {
  const providers = data?.providers || data?.Providers || [];
  const steps = data?.steps || data?.Steps || [];

  const cards = [
    ["نیازمند تسهیلات", data?.applicationsRequiringFinancing ?? data?.ApplicationsRequiringFinancing],
    ["تخصیص به لندتک", data?.assignedToLendingPartner ?? data?.AssignedToLendingPartner],
    ["ارسال به پلتفرم", data?.sentToLendingPlatform ?? data?.SentToLendingPlatform],
    ["تکمیل فرایند وام", data?.loanProcessComplete ?? data?.LoanProcessComplete],
    ["فرایند ناقص", data?.loanProcessIncomplete ?? data?.LoanProcessIncomplete],
  ];

  return (
    <ManagementWidgetShell
      title="نمای کلی وام"
      subheader="ارائه‌دهندگان به‌صورت پویا از SLN_LendingPartner.Code"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {cards.map(([label, value]) => (
          <Grid item xs={6} md={4} lg={2} key={label}>
            <Chip label={`${label}: ${value ?? 0}`} sx={{ width: "100%", justifyContent: "flex-start" }} />
          </Grid>
        ))}
      </Grid>

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        مقایسه ارائه‌دهندگان
      </Typography>
      <Table size="small" sx={{ mb: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>ارائه‌دهنده</TableCell>
            <TableCell>متقاضی</TableCell>
            <TableCell>ارسال‌شده</TableCell>
            <TableCell>تکمیل</TableCell>
            <TableCell>معطل</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {providers.map((p) => (
            <TableRow key={p.lendingProviderCode || p.LendingProviderCode}>
              <TableCell>{p.lendingProviderTitle || p.LendingProviderTitle}</TableCell>
              <TableCell>{p.applicantCount ?? p.ApplicantCount}</TableCell>
              <TableCell>{p.sentCount ?? p.SentCount}</TableCell>
              <TableCell>{p.completedCount ?? p.CompletedCount}</TableCell>
              <TableCell>{p.overdueCount ?? p.OverdueCount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        خط لوله ۹ مرحله‌ای وام
      </Typography>
      <StepPipelineList steps={steps} />
    </ManagementWidgetShell>
  );
};

export default LendingOverviewSection;
